import React from 'react';
import { LineCondition, LineConditionProps } from './LineCondition';

export interface ListConditionProps {
  conditions?: LineConditionProps[];
  isSubCondition?: boolean;
}

export const ListCondition = ({ conditions, isSubCondition }: ListConditionProps) => {
  if (!conditions || !conditions.length) return null;

  return (
    <div className="flex flex-col gap-2 w-full">
      {conditions.map((o) => (
        <LineCondition {...o} isSubCondition={isSubCondition} />
      ))}
    </div>
  );
};

